"use client";
import { GlobalTag, ItemWithGlobalTags } from "@/types";
import { useMemo, useState } from "react";
import { extractGlobalTags } from "../utils/extractGlobalTags";

export const useGlobalTagFilter = <T extends ItemWithGlobalTags>(
  items: T[]
): {
  filteredItems: T[];
  allTags: GlobalTag[];
  selectedTags: string[];
  setSelectedTags: React.Dispatch<string[]>;
} => {
  const [selectedTags, setSelectedTags] = useState<string[]>([]);

  const allTags = useMemo(() => extractGlobalTags(items), [items]);

  const filteredItems = useMemo(() => {
    if (selectedTags.length === 0) return items;
    return items.filter((item) =>
      item.globalTags?.some((tag) => selectedTags.includes(tag.id))
    );
  }, [items, selectedTags]);

  return {
    allTags,
    selectedTags,
    setSelectedTags,
    filteredItems,
  };
};
